import { Fragment } from "react";

import type { FilterDefinition } from "../config/structured-search-schema";
import { useStructuredSearchStore } from "../stores";

import FieldGroupHeader from "./FieldGroupHeader";
import FieldOptionRow from "./FieldOptionRow";

interface FieldSuggestionsSectionProps {
  suggestions: FilterDefinition[];
  highlightedIndex: number;
  disabled?: boolean;
  onSelect?: (index: number) => void;
}

const FieldSuggestionsSection = ({
  suggestions,
  highlightedIndex,
  disabled,
  onSelect,
}: FieldSuggestionsSectionProps) => {
  const store = useStructuredSearchStore();
  const { showGroupHeaders } = store.schema;
  let lastGroup: string | undefined;

  return (
    <>
      {suggestions.map((field, index) => {
        const isNewGroup = Boolean(field.group) && field.group !== lastGroup;
        lastGroup = field.group;

        const renderSeparator = () => {
          if (!isNewGroup) {
            return null;
          }
          if (showGroupHeaders && field.group) {
            return <FieldGroupHeader group={field.group} hasTopBorder={index > 0} />;
          }
          if (index > 0) {
            return (
              <li role="presentation" className="mx-2 px-2.5 py-1">
                <div aria-hidden className="h-px w-full bg-slate-100" />
              </li>
            );
          }
          return null;
        };

        return (
          <Fragment key={field.key}>
            {renderSeparator()}
            <FieldOptionRow
              field={field}
              highlighted={index === highlightedIndex}
              disabled={disabled}
              onSelect={onSelect ? () => onSelect(index) : undefined}
            />
          </Fragment>
        );
      })}
    </>
  );
};

export default FieldSuggestionsSection;
